import React from "react";
import styled from "styled-components";
import { THEME_COLORS } from "../../../ThemeConfig";
import icon from "../../../assets/icons/no-content.svg";

function NoSessionCard(selectedTab) {
  return (
    <MainContainer>
      <SubContainer>
        <IconContainer>
          <Icon src={icon} alt="Icon" />
        </IconContainer>
        <Title>No {selectedTab.selectedTab} sessions to show.</Title>
      </SubContainer>
    </MainContainer>
  );
}

export default NoSessionCard;

const MainContainer = styled.div`
  display: flex;
  padding: 48px 24px;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  align-self: stretch;
  border-radius: 16px;
  background: ${THEME_COLORS.surface_soft};
  border: 1px dashed ${THEME_COLORS.light_300};
`;
const SubContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
`;
const IconContainer = styled.div`
  width: 48px;
  height: 48px;
`;
const Icon = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
`;
const Title = styled.span`
  color: ${THEME_COLORS.text_para};
  text-align: center;
  font-family: "DM_sans";
  font-size: 15px;
  line-height: 1.5;
`;
